import {AbstractReactComponent, i18n, Icon} from 'mc/lib';
import {ListComponent} from 'mc/lib/list';
import {ModalActions} from 'mc/lib/modal';
import {formatDate, localUTCToDate} from 'mc/lib/utils/commons';
import React from 'react';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {LinkContainer} from 'react-router-bootstrap';
import {Button, Col, Row, Table} from 'reactstrap';
import {ZadostListActions} from '../actions';
import {Api} from '../api';
import {Loading} from '../components';
import {ZadostStav} from '../enums';
import './HomePage.scss';

class HomePage extends AbstractReactComponent {

    componentDidMount() {
        this.dispatch(ZadostListActions.fetchIfNeeded());
    }

    componentDidUpdate() {
        this.dispatch(ZadostListActions.fetchIfNeeded());
    }

    componentWillUnmount() {
        this.dispatch(ZadostListActions.invalidate());
    }

    zadostDuplicate = (id : number) => {
        Api.duplicateZadost(id).then((zadost) => {
            browserHistory.push(serverContextPath + '/zadost/' + zadost.id + '/nalezitosti');
        });
    };

    zadostDelete = (id : number, refCislo : string) => {
        this.props.dispatch(ModalActions.showConfirm(
            i18n('zadost.deletion.title'),
            i18n('zadost.deletion.confirm', refCislo),
            () => Api.deleteZadost(id).then(() => {
                this.dispatch(ZadostListActions.invalidate());
            }),
            null,
            i18n('global.delete'),
        ))
    };

    itemRender = (item) => {
        let state, actions;
        let datumOd = localUTCToDate(item.obdobiOd);
        let datumDo = localUTCToDate(item.obdobiDo);
        let obdobiDesc = '';
        if (item.obdobiOd && item.obdobiDo) {
            obdobiDesc = `${formatDate(datumOd)} - ${formatDate(datumDo)}`
        }
        switch (item.stav) {
            case ZadostStav.R:
                state = i18n('zadost.stav.' + item.stav);
                actions = <div>
                    <Button color="link" onClick={() => browserHistory.push(`${serverContextPath}/zadost/${item.id}/typ`)}>{i18n('zadost.edit')}</Button>
                    <Button color="link" onClick={() => this.zadostDuplicate(item.id)}>{i18n('global.duplicate')}</Button>
                    <Button color="link" onClick={() => this.zadostDelete(item.id, item.refCislo)}>{i18n('global.delete')}</Button>
                </div>;
                break;

            case ZadostStav.V:
                state = i18n('zadost.rozhodnuti.' + item.rozhodnuti);
                actions = <div>
                    <Button color="link" onClick={() => window.open(`${serverContextPath}/api/zadost/${item.id}/print/pdf`)}>{i18n('zadost.print.pdf')}</Button>
                    <Button color="link" onClick={() => this.zadostDuplicate(item.id)}>{i18n('global.duplicate')}</Button>
                    <Button color="link" onClick={() => window.open(`${serverContextPath}/api/zadost/${item.id}/print/rtf`)}>{i18n('zadost.print.rtf')}</Button>
                </div>;
                break;

            default:
                state = '';
                actions = null;
        }
        return <tr key={"zadost-" + item.id}>
            <td><span className="text">{item.refCislo.match(/.{4}/g).join('-')}</span></td>
            <td><span className="text">{item.typZabor.nazev}</span></td>
            <td><span className="text">{obdobiDesc}</span></td>
            <td><span className="text">{state}</span></td>
            <td>{actions}</td>
        </tr>;
    };

    render() {
        const {zadostList} = this.props;
        if (!zadostList || zadostList.isFetching || !zadostList.fetched) {
            return <Loading block="full"/>
        }
        return <Row className="zadost-list">
            <Col xs={12} lg={{size: 10, offset: 1}}>
                <h1>{i18n('zadost.list.title')}</h1>
                <ListComponent area="zadostList"
                               renderItem={this.itemRender}
                               renderContainer={child => (
                                    <Table striped bordered hover responsive>
                                        <thead>
                                        <tr>
                                            <th>{i18n('zadost.cislo')}</th>
                                            <th>{i18n('zadost.typ')}</th>
                                            <th>{i18n('zadost.obdobi')}</th>
                                            <th>{i18n('zadost.stav')}</th>
                                            <th>{i18n('zadost.akce')}</th>
                                        </tr>
                                        </thead>
                                        <tbody>{child}</tbody>
                                    </Table>
                                )}/>
                <LinkContainer to={serverContextPath + "/zadost"}>
                    <Button color="success" block>
                        <Icon icon="plus"/> {i18n('zadost.add')}
                    </Button>
                </LinkContainer>
            </Col>
        </Row>
    }
}

const mapStateToProps = state => ({
    zadostList: state.app.zadostList,
});

export default connect(mapStateToProps)(HomePage);
